<div class="row page-header">
    <div class="col-12">
        <h1>Firm Contacts <small>View firm contact information</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <action-toolbar-count [grid]="firmsGrid"></action-toolbar-count>
                        <action-toolbar-search name="search" [(ngModel)]="firmsGrid.filter"></action-toolbar-search>
                        <grid-export [grid]="gridFirms" [name]="'Firm Contacts'"></grid-export>
                    </form>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <wj-flex-grid
                        id="gridFirms"
                        #gridFirms
                        appAutoSize
                        [padding]="73"
                        (initialized)="firmsGrid.initialize(gridFirms)"
                        [itemsSource]="firmsGrid.view"
                        [childItemsPath]="'contacts'"
                    >
                        <wj-flex-grid-filter></wj-flex-grid-filter>
                        <!-- <wj-flex-grid-column
                            [header]="'Id'"
                            [binding]="'firmNumber'"
                            [width]="110"
                            [align]="'left'"
                            [format]="'d'"
                        ></wj-flex-grid-column> -->
                        <wj-flex-grid-column [header]="'Name'" [binding]="'name'" [width]="300"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Firm Type'" [binding]="'firmType'" [width]="150"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Contact'" [binding]="'contactName'" [width]="200"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Title'" [binding]="'title'" [width]="200"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Email'" [binding]="'email'" [width]="250"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Phone'" [binding]="'phone'" [width]="150"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Code 1'" [binding]="'code1'" [width]="'*'" [minWidth]="120"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Code 2'" [binding]="'code2'" [width]="'*'" [minWidth]="120"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Code 3'" [binding]="'code3'" [width]="'*'" [minWidth]="120"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Code 4'" [binding]="'code4'" [width]="100" [minWidth]="100"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'Code 5'" [binding]="'code5'" [width]="100" [minWidth]="100"></wj-flex-grid-column>
                    </wj-flex-grid>
                    <grid-selection-calculation [grid]="gridFirms"></grid-selection-calculation>
                </div>
            </div>
        </div>
    </div>
</div>
